import { useEffect, useState } from "react";

export default function TypewriterQueue({
  staticText = "Hello, ",
  lines = [],
  typeSpeed = 40,
  deleteSpeed = 30,
  lineDelay = 600,
  deleteDelay = 400,
}) {
  const [typedText, setTypedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let isMounted = true;

    async function loop() {
      while (isMounted) {
        const sentence = lines[index];
        let temp = "";

        // ----- Type Forward -----
        for (let char of sentence) {
          if (!isMounted) return;

          temp += char;
          setTypedText(temp);

          await new Promise((r) =>
            setTimeout(r, typeSpeed + Math.random() * 20)
          );
        }

        await new Promise((r) => setTimeout(r, deleteDelay));

        // ----- Delete Backward -----
        for (let i = temp.length; i >= 0; i--) {
          if (!isMounted) return;

          setTypedText(temp.slice(0, i));

          await new Promise((r) => setTimeout(r, deleteSpeed));
        }

        await new Promise((r) => setTimeout(r, lineDelay));

        setIndex((prev) => (prev + 1) % lines.length);
      }
    }

    loop();
    return () => (isMounted = false);
  }, [lines, index, staticText, typeSpeed, deleteSpeed, lineDelay, deleteDelay]);

  return (
    <div className="font-mono text-base text-slate-100 relative w-full">
      {/* Fixed left text block (never moves) */}
      <div className="inline-block min-w-[1px]">
        <span>{staticText}</span>
        <span>{typedText}</span>
        <span className="animate-pulse">|</span>
      </div>
    </div>
  );
}
